import { render, staticRenderFns } from "./ChannelItem.vue?vue&type=template&id=e4c2e8f0&scoped=true&"
import script from "./ChannelItem.vue?vue&type=script&lang=js&"
export * from "./ChannelItem.vue?vue&type=script&lang=js&"
import style0 from "./ChannelItem.vue?vue&type=style&index=0&id=e4c2e8f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c2e8f0",
  null
  
)

export default component.exports